import { createAction, props } from '@ngrx/store';

export const setRefreshTimerAction = createAction('[Refresh Search] Set refresh timer',
  props<{ refreshed: boolean }>()
);
